import { render, staticRenderFns } from "./VitalsAdjuster.vue?vue&type=template&id=463e4d12&scoped=true&"
import script from "./VitalsAdjuster.vue?vue&type=script&lang=js&"
export * from "./VitalsAdjuster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e4d12",
  null
  
)

export default component.exports